import React from 'react';
import { SearchOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

/**
 * UIInput - Input atom component
 */
const UIInput = ({
    placeholder = 'Enter text...',
    variant = 'default',
    disabled = false,
    value = '',
    state = 'default',
    deviceType = 'mobile',
    tokens
}) => {
    const neutralColor = tokens?.colors?.find(c => c.name === 'neutral')?.value || '#6b7280';

    // Get typography from tokens - use 'body' or 'input' style
    const inputTypo = tokens?.typography?.find(t => t.name === 'input')
        || tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 400, sizes: { mobile: 14, tablet: 14, desktop: 14 } };

    const fontSize = inputTypo.sizes?.[deviceType] || inputTypo.sizes?.mobile || 14;

    const baseStyles = {
        width: '100%',
        height: '100%',
        background: '#0d1117',
        border: '1px solid #30363d',
        borderRadius: 6,
        padding: '0 12px',
        fontFamily: inputTypo.fontFamily || 'Inter, system-ui, sans-serif',
        fontSize: fontSize,
        fontWeight: inputTypo.weight || 400,
        color: '#c9d1d9',
        display: 'flex',
        alignItems: 'center',
        opacity: disabled ? 0.5 : 1
    };

    const placeholderStyles = {
        color: '#484f58'
    };

    const renderIcon = () => {
        if (variant === 'search') {
            return (
                <SearchOutlined style={{
                    color: '#484f58',
                    marginRight: 8,
                    fontSize: 14
                }} />
            );
        }
        if (variant === 'password') {
            return (
                <EyeInvisibleOutlined style={{
                    color: '#484f58',
                    marginLeft: 'auto',
                    fontSize: 14
                }} />
            );
        }
        return null;
    };

    return (
        <div style={baseStyles}>
            {variant === 'search' && renderIcon()}
            <span style={value ? {} : placeholderStyles}>
                {value || placeholder}
            </span>
            {variant === 'password' && renderIcon()}
        </div>
    );
};

export default UIInput;
